import { KettleOffIcon } from './KettleOffIcon';

/**
 * author: Michael Irigoyen
 * id A28C7FA8-2D3A-482A-ADC8-46391CF201E1
 * name kettle-off
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/kettle-off.svg
 * tags
 * - Home Automation 
 * - Food / Drink 
 */
export const TeaKettleOffIcon = KettleOffIcon;
export default TeaKettleOffIcon